import httpClient from "../config/httpClient";
import { HttpUtil } from "../config/httpUtil";
import { SearchProductFilters } from "@/models/product.model";

export abstract class InventoryProductService {
	private static readonly BASE_URL = "/sys03/inventory/products";
	private static readonly DASHBOARD_URL = InventoryProductService.BASE_URL.concat("/dashboard");

	public static getDashboard({ filters }: { filters: SearchProductFilters }) {
		const url = `${InventoryProductService.DASHBOARD_URL}`;
		const params = HttpUtil.getFiltersParameters({ filters });

		return httpClient.get(url, { params });
	}
}
